module.exports = __webpack_public_path__ + "static/media/boxing.2171348b.svg";